export const LEVEL = {
  EASY: 'easy',
  MEDIUM: 'medium',
  HARD: 'hard',
};

export const LEVEL_OPTIONS = [
  {
    slug: LEVEL.EASY,
    labelKey: 'shared.level.easy',
    color: 'text-success',
  },
  {
    slug: LEVEL.MEDIUM,
    labelKey: 'shared.level.medium',
    color: 'text-warning',
  },
  {
    slug: LEVEL.HARD,
    labelKey: 'shared.level.hard',
    color: 'text-danger',
  },
];

export const LEVELS = Object.values(LEVEL);

const LEVEL_BY_SLUG = Object.fromEntries(
  LEVEL_OPTIONS.map(level => [level.slug, level]),
);

export const getLevelOption = slug => LEVEL_BY_SLUG[slug];

export const getLevelLabelKey = slug => {
  const labelKey = LEVEL_BY_SLUG[slug]?.labelKey;
  return labelKey || '';
};

export const getLevelColor = slug => {
  const color = LEVEL_BY_SLUG[slug]?.color;
  return color || '';
};
